import React, { useState } from "react";
import { Send, Loader2, FlaskConical, UserRound } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLang } from "@/context/LangContext";

// غرفة اختبار: محادثة تجريبية مع البوت دون إرسال شيء على واتساب
export const BotTester = ({ bot }) => {
  const { t } = useLang();
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    const m = text.trim();
    if (!m || busy) return;
    setText(""); setBusy(true);
    const hist = msgs;
    setMsgs((s) => [...s, { role: "user", text: m }]);
    try {
      const r = await api.post(`/wa-bot/${bot.id}/test`, { message: m, history: hist });
      setMsgs((s) => [...s, { role: "bot", text: r.data.reply, handoff: r.data.handoff }]);
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-border bg-card flex flex-col h-[420px]" data-testid="bot-tester">
      <div className="px-4 py-2.5 border-b border-border text-xs font-bold flex items-center gap-1.5"><FlaskConical className="w-3.5 h-3.5 text-primary" /> {t("غرفة الاختبار — جرّب كما لو كنت عميلًا (لا يُرسل شيء على واتساب)", "Test room — chat as a customer (nothing is sent on WhatsApp)")}</div>
      <div className="flex-1 overflow-y-auto p-3 space-y-2 bg-[#efeae2] dark:bg-background/40">
        {msgs.length === 0 && <div className="text-center text-xs text-muted-foreground py-10">{t("اكتب «مرحبا» لترى تحية البوت ثم اسأله عن خدماتك وأسعارك", "Type “hi” to see the greeting, then ask about your services")}</div>}
        {msgs.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-start" : "justify-end"}`}>
            <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-white dark:bg-secondary" : "bg-[#d9fdd3] dark:bg-emerald-900/40"}`} data-testid={`bot-test-msg-${i}`}>
              {m.text}
              {m.handoff && <div className="mt-1 text-[10px] text-amber-700 flex items-center gap-1"><UserRound className="w-3 h-3" /> {t("سيُحوَّل للبشر + تنبيه بالبريد", "Hand-off to human + email alert")}</div>}
            </div>
          </div>
        ))}
        {busy && <div className="flex justify-end"><div className="rounded-2xl px-3 py-2 bg-[#d9fdd3] dark:bg-emerald-900/40"><Loader2 className="w-4 h-4 animate-spin" /></div></div>}
      </div>
      <div className="p-2 border-t border-border flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder={t("اكتب رسالة تجريبية…", "Type a test message…")} data-testid="bot-test-input" />
        <Button onClick={send} disabled={busy || !text.trim()} size="icon" data-testid="bot-test-send"><Send className="w-4 h-4" /></Button>
      </div>
    </div>
  );
};
